/**
 * Update date: 31-05-2023
 * Screen 2052.2
 */
import LoadPanel from 'app/components/LoadPanel';
import MenuSound from 'app/components/MenuSound';
import ArrayStore from 'devextreme/data/array_store';
import React, { createContext, useContext, useRef, useState } from 'react';

const List = React.lazy(() => import('./List'));
/**
 * create context
 */
const ManualRegistrationPCContext = createContext({
  emptyBottleDepositListData: [],
});

ManualRegistrationPCContext.displayName = 'ManualRegistrationPCContext';

export const useManualRegistrationPC = () => {
  const context = useContext(ManualRegistrationPCContext);
  return context;
};

export default function ManualRegistrationPC() {
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const dataGridRef: any = useRef(null);
  const [emptyBottleDepositListData, setEmptyBottleDepositListData] = useState(
    [],
  );
  const [listDataBarcode, setListDataBarCode] = useState<any>([]);
  // Get data

  const store: any = new ArrayStore({
    data: listDataBarcode,
    key: 'productSku',
  });

  /**
   * on clear data grid
   *
   */
  const onClearDataGrid = () => {
    setListDataBarCode([]);
  };

  const value: any = {
    selectedTabIndex,
    setSelectedTabIndex,
    store,
    dataGridRef,
    listDataBarcode,
    setListDataBarCode,
    onClearDataGrid,
    emptyBottleDepositListData,
    setEmptyBottleDepositListData,
  };

  return (
    <ManualRegistrationPCContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <List ref={dataGridRef} />
        <MenuSound />
      </React.Suspense>
    </ManualRegistrationPCContext.Provider>
  );
}
